import { useQuery } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { MeetingSchedulerGuests } from "../../types/Types";

export function useGetMeetingSchedulerGuests(
  id: number | null | undefined,
  { enabled = true }: { enabled?: boolean } = {}
) {
  return useQuery({
    enabled: enabled && !!id,
    queryKey: ["meeting-scheduler-guests", id],
    queryFn: async () => {
      const res = await axiosInstance.get<MeetingSchedulerGuests>(
        getAPIURL(`/MeetingScheduler/${id}/guests`)
      );
      return res.data;
    },
  });
}
